import React from 'react'
import '../App.css'

export default function Contact() {
  return (
    <div>
        <br/>
        <br/>
        <br/>
        
        <div class="section-header"><br></br>           
             <p><span class="contact12img">Contact</span></p>
          </div>   
        
        <img src={require('../assets/img/tour.jpg')} class="contactimg" id="imgcontact" alt="logo" />
<br/>
<br/>
        {/* <form action="forms/contact.php" method="post" role="form" class="php-email-form p-3 p-md-4">
          <div class="row">
            <div class="col-xl-6 form-group">
              <input type="text" name="name" class="form-control rounded-pill" id="name" placeholder="Your Name" required/>
            </div>

            <div class="col-xl-6 form-group">
              <input type="email" class="form-control rounded-pill " name="email" id="email" placeholder="Your Email" required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-xl-6 form-group">
              <input type="text" name="Time" class="form-control rounded-pill" id="Time" placeholder="Time" required/>
            </div>

            <div class="col-xl-6 form-group">
              <input type="Date" class="form-control rounded-pill " name="date" id="date" placeholder="date" required/>
            </div>
          </div>
          <br/>
          <div class="form-group ">
            <input type="text" class="form-control rounded-pill" name="messsage" id="message" placeholder="Subject" required/>
          </div>
          <br/>
          <div class="form-group">
            <textarea class="form-control " name="message" rows="5" placeholder="Message" required></textarea>
          </div>
          <div class="my-3">
            <div class="loading">Loading...</div>
            <div class="error-message"></div>
            <div class="sent-message">Your message has been ready. Thank you!</div>
          </div>
          <button><a href="" className='rounded-pill m-5'>Send Messge</a></button>
        </form> */}
        <wrapper className='section'>
          <h2 className='common-heading'>ENTER DETAILS</h2>
          <div className='container'>
            <div className='contact-form'>
              <form action="https://formspree.io/f/mjvqkrqg" method="POST" className='contact-inputs'>
                <input type="name" name='name'  placeholder='name' autoComplete='off' required />
                <input type="email" name='username'  placeholder='E-mail' autoComplete='off' required />
                <input type="numbers" name='PhoneNo'  placeholder='Phone-No' autoComplete='off' required />
                <input type="date" name='Time'  placeholder='Date DD-MM-YY' autoComplete='off' required />
                <input type="submit" value="send" />
              </form>
            </div>
          </div>
        </wrapper>
        <br/>
    </div>
  )
}

                            